import React, { useContext } from 'react';
import parse from 'html-react-parser';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getTranslationByKey } from '../../helpers/translation-helper';
import { DWTCContext } from '../../utils/context';
import {
  DwtcVirtualAssetsIntroWrapper,
  DwtcVirtualAssetsIntroContainer,
  DwtcVirtualAssetsIntroBody,
  DwtcVirtualAssetsIntroTitleText,
  DwtcVirtualAssetsIntroTitle,
  DwtcVirtualAssetsIntroText,
  DwtcVirtualAssetsIntroAccordion,
  DwtcVirtualAssetsIntroAccordionButton,
  DwtcVirtualAssetsIntroAccordionBody,
  DwtcVirtualAssetsVaraImage,
  DwtcVirtualAssetsIntroAccordionItem,
} from '../styles/VirtualAssetsIntro.style';

export default function DwtcVirtualAssetsIntro({ data, dir }) {
  const { contentTypeAlias, title, subtitle, description, dwtcVirtualAssetsIntroAccordionList } =
    data;
  const { translations } = useContext(DWTCContext);
  const [clicked, setClicked] = React.useState(null);

  const toggle = (index) => {
    if (clicked === index) {
      return setClicked();
    }

    setClicked(index);
    return index;
  };
  return (
    <DwtcVirtualAssetsIntroWrapper id={contentTypeAlias}>
      <DwtcVirtualAssetsIntroContainer>
        <DwtcVirtualAssetsIntroBody>
          <DwtcVirtualAssetsIntroTitleText>
            <DwtcVirtualAssetsIntroTitle>{title}</DwtcVirtualAssetsIntroTitle>
            <DwtcVirtualAssetsIntroText dir={dir}>
              <p>{subtitle}</p>
              <p>{description}</p>
            </DwtcVirtualAssetsIntroText>
          </DwtcVirtualAssetsIntroTitleText>
          <DwtcVirtualAssetsIntroAccordion>
            {isEmpty(dwtcVirtualAssetsIntroAccordionList) ||
              dwtcVirtualAssetsIntroAccordionList.map((item, index) => (
                <div key={index} className="intro_div">
                  <DwtcVirtualAssetsVaraImage>
                    {isEmpty(item.content.image) || (
                      <LazyLoadImage src={item.content.image.url} alt={title} />
                    )}
                  </DwtcVirtualAssetsVaraImage>
                  <DwtcVirtualAssetsIntroAccordionItem
                    className={`${clicked === index ? 'acc-up' : 'acc-down'}`}
                  >
                    <DwtcVirtualAssetsIntroAccordionButton
                      onClick={() => toggle(index)}
                      dir={dir}
                      className={clicked === index ? 'active' : ''}
                    >
                      <div>
                        <div className="button-text">
                          <span dir={dir}>{getTranslationByKey(translations, 'VARA')}</span>
                          <h4 dir={dir}>{item.content.subtitle}</h4>
                        </div>
                        <p dir={dir}>{item.content.title}</p>
                      </div>

                      <span className={`arrow ${clicked === index ? 'arrow-down' : 'arrow-up'}`} />
                    </DwtcVirtualAssetsIntroAccordionButton>
                    {clicked === index ? (
                      <DwtcVirtualAssetsIntroAccordionBody dir={dir}>
                        {parse(item.content.text)}
                      </DwtcVirtualAssetsIntroAccordionBody>
                    ) : null}
                  </DwtcVirtualAssetsIntroAccordionItem>
                </div>
              ))}
          </DwtcVirtualAssetsIntroAccordion>
        </DwtcVirtualAssetsIntroBody>
      </DwtcVirtualAssetsIntroContainer>
    </DwtcVirtualAssetsIntroWrapper>
  );
}